/**
 * @author rmh
 * 模块说明：退货申请单管理
 */
import { Service } from '@/tools'

export class entryAndExitFormService<T extends TProcurementStrategy.entryAndExitForm> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(
    url: `${P}/${keyof TProcurementStrategy.entryAndExitForm}`,
    data?: TCommon.Json,
    toast?: string
  ) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：列表相关接口
   */
  entryPage = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }
  /**
   * 模块说明：退货单详情
   */
  entryDetail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiDetail', data)
  }
  /**
   * 模块说明：关联单据
   */
  entryRelatedOrder = <K extends T['ApiRelatedOrder']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiRelatedOrder', data)
  }
  /**
   * 模块说明：进退单-导出
   */
  entryExportExcel = <K extends T['ApiExportExcel']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiExportExcel', data)
  }
  /**
   * 模块说明：进退单-明细导出
   */
  entryDetailExport = <K extends T['ApiDetailExport']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiDetailExport', data)
  }
}
